// extracted by mini-css-extract-plugin
module.exports = {"contentContainer":"_3kruT","fullOpacity":"gX2hs","content":"_1fkkE","triangleWrapper":"Sv_Mk","top":"_2kI5O","right":"_1f2K2","left":"_1yj15","bottom":"_2qOjl","triangle":"Ekah1"};